/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import settings from 'settings'
import Switch from 'react-switch'

import Icon from 'app/views/components/Icon'


class SelectCustomAssessmentContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const languages = this.props.codeReviews.map((language) => language.language_name)
    const {
      onChangeValue,

      selectedContent,
      selectedFilter,
      title,
      description,
      allowHints,
      error,
      isTemplate,
      isHackedu,
    } = this.props
    return (
      <div className="uk-card uk-card-default uk-card-body">
        {isHackedu && (
          <div
            className="uk-margin uk-text-center uk-container-small uk-align-center"
          >
            <p>
              The content or the title from a Default Assessments can't be modified.
              Nevertheless you can change the time limits of the content, the Allow Hints
              option or use it as template to create a new Assessment.
            </p>
            <button
              onClick={this.props.onTemplate}
              className="uk-button uk-button-primary uk-button-small"
              type="button"
            >
              Use as Template
            </button>
          </div>
        )}
        <div className="uk-container-small">
          <form className="uk-form-stacked">
            {!isHackedu && (
              <div className="uk-margin">
                <label className="uk-form-label">Title</label>
                <div className="uk-form-controls">
                  <input
                    className="uk-input"
                    type="text"
                    placeholder=""
                    value={title || ''}
                    onChange={(e) => onChangeValue('title', e.target.value)}
                    data-test-id="input-title"
                  />
                  {Boolean(error) && <span className="uk-text-danger">{error}</span>}
                </div>
              </div>
            )}
            {/* ---- */}
            <div className="uk-margin">
              <label className="uk-form-label">Description</label>
              <div className="uk-form-controls">
                <input
                  data-test-id="input-description"
                  className="uk-input"
                  type="text"
                  placeholder=""
                  value={description || ''}
                  onChange={(e) => onChangeValue('description', e.target.value)} />
              </div>
            </div>
            {/* ---- */}
            <div className="uk-margin">
              <label className="uk-form-label">Settings</label>
              <div className="uk-inline">
                <Switch
                  onChange={() => onChangeValue('allowHints', !allowHints)}
                  checked={allowHints}
                  id="normal-switch"
                  offColor="#999999"
                  onColor="#1e87f0"
                  checkedIcon={false}
                  uncheckedIcon={false}
                />
                <span style={{ paddingLeft: 10, verticalAlign: 'top' }}>
                  Allow hints.
                </span>
                <Icon
                  as="a"
                  href="https://help.hackedu.com/en/articles/3969527-assessment-hints"
                  name="information"
                  ratio={0.8}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    cursor: 'pointer',
                    paddingLeft: 8,
                    paddingTop: 6,
                    verticalAlign: 'top',
                  }}
                />
              </div>
            </div>
            {/* ---- */}
          </form>
        </div>
        <div className="uk-margin">
          <label className="uk-form-label">
            Filter by language
          </label>
          <div className="uk-form-controls">
            <select
              className="uk-select uk-width-1-4"
              value={selectedFilter}
              onChange={(e) => { onChangeValue('selectedFilter', e.target.value) }}
            >
              <option value="">Show All</option>
              {languages.map((l) => <option key={l} value={l}>{settings.engines[l]}</option>)}
            </select>

            <button
              onClick={this.props.onNext}
              className="uk-button-primary uk-button uk-align-right"
              type="button"
              disabled={Object.keys(selectedContent).length === 0}
            >
              {/* {this.isEdit ? 'Save Assessment' : 'Create Assessment'} */}
              Next
            </button>
          </div>
        </div>
        <div
          className="uk-margin"
        >
          <table
            className="uk-table uk-table-divider uk-table-small uk-text-small uk-table-middle uk-text-center"
          >
            <thead
              className=""
            >
              <tr>
                <th
                  className="uk-width-1-6 uk-text-center"
                >
                  Language
                </th>
                <th
                  className="uk-width-1-6 uk-text-center"
                >
                  Framework
                </th>
                <th
                  className="uk-width-1-6 uk-text-center"
                >
                  App
                </th>
                <th>
                  Vulnerability
                </th>
                {!isTemplate && (
                  <th />
                )}
              </tr>
            </thead>
            <tbody>
              {this.props.codeReviews.filter((codeReviewItem) => {
                if (!isTemplate) {
                  return true
                }
                return Object.values(selectedContent).some((selectedContentItem) => selectedContentItem.language === codeReviewItem.language_name)
              }).map((language) => {
                if (selectedFilter !== '' && selectedFilter !== language.language_name) {
                  return null
                }
                const totalContentInLanguage = language.frameworks.reduce((p, f) => {
                  let total = 0
                  f.apps.forEach((a) => {
                    if (isTemplate) {
                      total += a.content.filter((c) => Object.keys(selectedContent).includes(c.uuid)).length
                    } else {
                      total += a.content.length
                    }
                  })
                  return total + p
                }, 0)
                const hasLanguage = Object.values(selectedContent).some((selContent) => {
                  if (selContent.language === language.language_name) {
                    return true
                  }
                  return false
                })
                return language.frameworks.filter((frameworkItem) => {
                  if (!isTemplate) {
                    return true
                  }
                  return Object.values(selectedContent).some((selectedContentItem) => selectedContentItem.framework === frameworkItem.name)
                }).map((framework, frameworkIndex) => {
                  const totalContentInFramework = framework.apps.reduce((p, a) => {
                    if (!isTemplate) {
                      return a.content.length + p
                    }
                    return a.content.filter((c) => Object.keys(selectedContent).includes(c.uuid)).length + p
                  }, 0)
                  const hasLanguageFramework = framework.apps.some((app) => {
                    const show = app.content.some((c) => selectedContent[c.uuid])
                    return show
                  })
                  return framework.apps.filter((appItem) => {
                    if (!isTemplate) {
                      return true
                    }
                    return Object.values(selectedContent).some((selectedContentItem) => selectedContentItem.app === appItem.name)
                  }).map((app, appIndex) => {
                    const totalContentInApp = app.content.length
                    const hasApp = app.content.some((c) => selectedContent[c.uuid])
                    return app.content.filter((contentItem) => {
                      if (!isTemplate) {
                        return true
                      }
                      return Boolean(selectedContent[contentItem.uuid])
                    }).map((content, contentIndex) => {
                      const firstOfLanguage = appIndex === 0 && contentIndex === 0 && frameworkIndex === 0
                      const firstOfFramework = contentIndex === 0 && appIndex === 0
                      const firstOfApp = contentIndex === 0
                      const contentSelected = selectedContent[content.uuid]
                      return (
                        <tr key={`${language.language_name}-${framework.name}-${app.name}-${content.uuid}`}>
                          {firstOfLanguage && (
                            <td
                              rowSpan={totalContentInLanguage}
                              className="uk-text-center"
                              style={{
                                borderRight: '1px solid #e5e5e5',
                                background: contentSelected || hasLanguageFramework || hasLanguage ? '#edfbf6' : null,
                              }}
                            >
                              <i
                                className={`devicon-${settings.engineIcons[language.language_name]}-plain colored`}
                                style={{ fontSize: 50 }}
                                title={settings.engines[language.language_name]}
                              />
                              <div className="uk-divider-small" />
                              <h4 className="uk-margin-remove">
                                {settings.engines[language.language_name]}
                              </h4>
                            </td>
                          )}
                          {firstOfFramework && (
                            <td
                              rowSpan={totalContentInFramework}
                              style={{
                                borderRight: '1px solid #e5e5e5',
                                background: contentSelected || hasLanguageFramework ? '#edfbf6' : null,
                              }}
                            >
                              <h4>
                                {settings.frameworks[framework.name]}
                              </h4>
                            </td>
                          )}
                          {firstOfApp && (
                            <td
                              rowSpan={totalContentInApp}
                              style={{
                                borderRight: '1px solid #e5e5e5',
                                background: contentSelected || hasApp ? '#edfbf6' : null,
                              }}
                            >
                              <h5>
                                <strong>
                                  {settings.apps[app.name]}
                                </strong>
                              </h5>
                            </td>
                          )}
                          <td
                            style={{
                              background: contentSelected ? '#edfbf6' : null,
                            }}
                            className="uk-text-left"
                          >
                            {content.title}
                          </td>
                          {!isTemplate && (
                            <td
                              className={isHackedu ? '' : 'uk-text-right'}
                              style={{
                                background: contentSelected ? '#edfbf6' : null,
                              }}
                            >
                              {
                                selectedContent[content.uuid] && selectedContent[content.uuid].timeLimit ? (
                                  <span
                                    className="uk-label uk-label-primary uk-margin-small-right uk-text-lowercase uk-text-center"
                                    style={{
                                      width: 65,
                                    }}
                                  >
                                    {`${selectedContent[content.uuid].timeLimit} min.`}
                                  </span>
                                ) : null
                              }
                              {!isHackedu && !isTemplate && (
                                <Switch
                                  onChange={() => this.props.onToggleContent(content, language, framework, app)}
                                  checked={Boolean(selectedContent[content.uuid])}
                                  width={40}
                                  height={20}
                                  id="normal-switch"
                                  offColor="#999999"
                                  onColor="#1e87f0"
                                  checkedIcon={false}
                                  uncheckedIcon={false}
                                />
                              )}
                            </td>
                          )}
                        </tr>
                      )
                    })
                  })
                })
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default SelectCustomAssessmentContent
